// src/redux/salaryApi.js
import { apiSlice } from ".";
import { toast } from "react-toastify";

const salaryApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({

       postBulkSalary: builder.mutation({
      query: (bulkSalaryData) => ({
        url: "/Salary/PostBulkSalary",
        method: "POST",
        body: bulkSalaryData,
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        toast.promise(queryFulfilled, {
          pending: "Saving bulk salary...",
          success: "Bulk salary saved successfully ",
          error: "Error saving bulk salary ",
        });
      },
    }),
    postSalary: builder.mutation({
      query: (salaryData) => ({
        url: "/Salary/PostSalary",
        method: "POST",
        body: salaryData,
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        toast.promise(queryFulfilled, {
          pending: "Saving salary...",
          success: "Salary saved successfully ✅",
          error: "Error saving salary ❌",
        });
      },
    }),

    postAdvanceSalary: builder.mutation({
      query: (advanceSalaryData) => ({
        url: "/Salary/PostAdvanceSalary",
        method: "POST",
        body: advanceSalaryData,
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        toast.promise(queryFulfilled, {
          pending: "Saving advance salary...",
          success: "Advance salary saved successfully ✅",
          error: "Error saving advance salary ❌",
        });
      },
    }),

    getAgentSalary: builder.query({
      query: (agentId) => `/Salary/GetAgentSalaryDetails?agentid=${agentId}`,
      transformResponse: (response) => response,
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          toast.error("Failed to fetch agent's Base Salary ❌");
        }
      },
    }),

    getIncomeReport: builder.query({
      query: ({ agencyId, fromDate, toDate }) =>
        `/Salary/GetIncomeReport?agencyid=${agencyId}&fromdate=${fromDate}&todate=${toDate}`,
      transformResponse: (response) => response,
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
          toast.success("Income Report fetched successfully ✅");
        } catch (err) {
          toast.error("Failed to fetch Income Report ❌");
        }
      },
    }),

    getAgencySalaryDetails: builder.query({
      query: ({ agencyId, month, year }) =>
        `/Salary/GetAgencySalaryDetails?agencyId=${agencyId}&month=${month}&year=${year}`,
      transformResponse: (response) => response,
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          toast.error("Failed to fetch Agency Salary details ❌");
        }
      },
    }),

    getAgentAccountDetails: builder.query({
      query: ({ agencyId, month, year }) =>
        `/Salary/GetAgentAccountDetails?agencyid=${agencyId}&month=${month}&year=${year}`,
      transformResponse: (response) => response,
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          toast.error("Failed to fetch Agent Account details ❌");
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  usePostBulkSalaryMutation,
  usePostSalaryMutation,
  usePostAdvanceSalaryMutation,
  useLazyGetAgentSalaryQuery,
  useLazyGetAgencySalaryDetailsQuery,
  useLazyGetIncomeReportQuery,
  useLazyGetAgentAccountDetailsQuery,
} = salaryApi;
